import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import { assigneeToAvatarUser } from '@core/ask-hr-smart-ui';
import type { AskTemplateViewItem } from '@core/ask-hr-types';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import { SymbolComponent } from '@core/symbol-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'ask-chat-form-item',
  imports: [
    HeadingComponent,
    ProsemirrorBasicConfigDirective,
    RenderDirective,
    SymbolComponent,
    AdminsAvatarsComponent,
  ],
  templateUrl: './chat-form-item.component.html',
  styleUrl: './chat-form-item.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card rt-card-clickable',
  },
})
export class ChatFormItemComponent {
  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  public template = input.required<AskTemplateViewItem>();

  protected assignedUsers = computed((): AvatarUser[] =>
    this.template().autoAssignees.map(assignee => assigneeToAvatarUser(assignee)),
  );
}
